import type { FC } from 'react';
import type { TableColumn } from '@interstate/components/Table';
import { Table } from '@interstate/components/Table';
import type { IAuditLogField, IAuditLogChange, IDealChangeRecord } from '@makemydeal/dr-platform-types';
import NestedChangeLogTable from './ChangeInAllVersionList';
import { transformation } from '../Transformation';

const ChangeLogTable: FC<{
    changeLogData: (IAuditLogField & { key: number })[];
    handleSetSlideoutProps: (selectedItem: IDealChangeRecord) => void;
}> = ({ changeLogData, handleSetSlideoutProps }) => {
    const columnDefs: TableColumn[] = [
        {
            dataIndex: 'date',
            title: 'Date/Time',
            width: 110,
            render: (value) => transformation.transformationDateTime(value)
        },
        {
            dataIndex: 'displayName',
            title: 'Field Name',
            render: (_, record) => transformation.transformationFieldName(record)
        },
        {
            dataIndex: 'previousValue',
            title: 'Old Value',
            render: (_, record) =>
                transformation.transformArrayValue(
                    record.previousValue,
                    {
                        onArrayClick: () => {
                            // Handle click on previous value array
                            handleSetSlideoutProps(record);
                        }
                    },
                    record.fieldPath
                )
        },
        {
            dataIndex: 'currentValue',
            title: 'New Value',
            render: (_, record) =>
                transformation.transformArrayValue(
                    record.currentValue,
                    {
                        onArrayClick: () => {
                            // Handle click on current value array
                            handleSetSlideoutProps(record);
                        }
                    },
                    record.fieldPath
                )
        },
        {
            dataIndex: 'modifiedBy',
            title: 'Modified By',
            render: (value) => transformation.transformationModifiedBy(value)
        }
    ];

    return (
        <Table
            data-testid="change-log-table"
            className="change-log-table"
            columns={columnDefs}
            data={changeLogData}
            dataDensity="small"
            bordered={true}
            highlightOnHover={false}
            sortableColumns={false}
            defaultPageSize={400}
            expandedRowComponent={(record) => (
                <NestedChangeLogTable
                    data={(record?.changes || []).map((item: IAuditLogChange, index: number) => ({
                        ...item,
                        fieldPath: record.fieldPath,
                        key: index
                    }))}
                    handleSetSlideoutProps={handleSetSlideoutProps}
                />
            )}
        />
    );
};

export default ChangeLogTable;
